import { render, staticRenderFns } from "./graphicDetails.vue?vue&type=template&id=bbf6aba0&scoped=true&"
import script from "./graphicDetails.vue?vue&type=script&lang=js&"
export * from "./graphicDetails.vue?vue&type=script&lang=js&"
import style0 from "./graphicDetails.vue?vue&type=style&index=0&id=bbf6aba0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf6aba0",
  null
  
)

export default component.exports